<template>
      <v-container fluid class="primary pb-12">
        <v-container>
            <v-row class="">
                <v-col>
                    <h1 class="fifth--text display-2 mb-4">Curriculars</h1>
                </v-col>
            </v-row>
            <v-row class="d-flex align-center justify-space-between">
                <v-col v-for="proj in this.projects" :key="proj.name" md="6" cols="12">
                    <v-card class="fifth" height="100%" flat raised >
                        <v-row >
                            <v-col cols="2" class="pt-0 pb-0 pr-0">
                        <v-img
                        style="border-radius: 2px;"
                        :src="proj.img"
                        height="100%"
                        
                        />                        
                            </v-col>
                            <v-col>
                        <v-card-title class="primary--text headline font-weight-bold">{{ proj.title }}</v-card-title>
                        <v-card-subtitle class="primary--text title font-weight-regular">{{ proj.subtitle }}</v-card-subtitle>
                        <v-card-text class="primary--text subtitle-1 font-weight-regular">{{ proj.text }}</v-card-text>

                            </v-col>
                        </v-row>

                    </v-card>
                </v-col>                
            </v-row>
        </v-container>
      </v-container>

</template>

<script>       
export default {
data: ()=> {
    return {
        
            projects: [{
                title: 'Computer Science Representative',
                subtitle: 'School Club Executive',
                text: 'Elected to coordinate workshops for UBC students in computer science topics such as Java, Vue.js, JavaScript, HTML, CSS, Git.',
                img: 'https://github.com/rogov-dvp/Images/blob/master/personal-web/QSCU.png?raw=true',
            },{
                title: 'BCHacks',
                subtitle: 'Hackathon',
                text: 'Participated and lead a team of 3 to develop a web app which takes a user\'s ingredient input and returns recipes that can be made with those ingredients.',
                img: 'https://github.com/rogov-dvp/Images/blob/master/personal-web/BCHacks.png?raw=true',   
           }],
    }
}
}
</script>

<style>

</style>